import React, { useState, useEffect, useRef } from 'react';
import LandingIntro from './LandingIntro';
import ErrorText from './ErrorText';
import InputText from './InputText';
import { createClient } from '@supabase/supabase-js';
import HCaptcha from '@hcaptcha/react-hcaptcha';

// SUPABASE_URL and SUPABASE_PUBLISHABLE_KEY are injected at build time by
// webpack's DefinePlugin (see backend/word_plugin/webpack.config.js).
// eslint-disable-next-line no-undef
const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
const HCAPTCHA_SITEKEY = '9db0aa10-d496-439a-8c60-96321f02a61a';

function userSignedIn(userInfo) {
  // Return the user info object back to taskpane
  Office.context.ui.messageParent(JSON.stringify(userInfo));
}

function Login() {
  const EMAIL_TOKEN = localStorage.getItem('email');
  const captcha = useRef(null);

  let INITIAL_LOGIN_OBJ = {
    password: '',
    emailId: '',
  };

  if (EMAIL_TOKEN) {
    INITIAL_LOGIN_OBJ.emailId = EMAIL_TOKEN;
  }

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loginObj, setLoginObj] = useState(INITIAL_LOGIN_OBJ);
  const [captchaToken, setCaptchaToken] = useState(null);

  const saveProfileToLocalStorage = async (sessionData) => {
    let { data: profiles, error2 } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', sessionData.user.id);

    const userInfo = {
      token: sessionData.session.access_token,
      plan: profiles[0].plan,
      char_limit: profiles[0].char_limit,
      batch_limit: profiles[0].batch_limit,
      apikey: profiles[0].api_key,
      email: profiles[0].email,
      fullname: profiles[0].full_name,
      id: profiles[0].id,
      accessToken4: sessionData.session.access_token,
    };

    userSignedIn(userInfo);

    setLoading(false);
  };

  const signInIfPossible = () => {
    console.log('Signing in if possible');
    supabase.auth.getSession().then(({ data, error }) => {
      if (error) {
        console.error(error);
      }
      if (data.session === null) {
        console.log('No session found');
      } else {
        console.log(data);
        supabase.auth.getUser().then((response) => {
          if (response.error) {
            console.error(response.error);
          }
          if (response.data) {
            data.user = response.data.user;
            console.log('Logging in with OAuth');
            saveProfileToLocalStorage(data);
          }
        });
      }
    });
  };

  let searchParams = new URLSearchParams(window.location.search);

  if (searchParams.get('signedin') === 'true') {
    signInIfPossible();
  }
  // useEffect(() => {
  //     signInIfPossible();
  // }, []);

  const submitForm = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (loginObj.emailId.trim() === '')
      return setErrorMessage('Email Id is required!');
    if (loginObj.password.trim() === '')
      return setErrorMessage('Password is required!');
    if (!captchaToken) return setErrorMessage('Captcha token is required!');
    else {
      setLoading(true);
      let { data, error } = await supabase.auth.signInWithPassword({
        email: loginObj.emailId,
        password: loginObj.password,
        options: { captchaToken },
      });
      console.log(data);

      if (error) {
        setLoading(false);
        if (error.message == 'Email not confirmed') {
          setErrorMessage(
            'Email is not confirmed. Please check your email to confirm sign up.'
          );
        } else {
          setErrorMessage('Failed to login. Please check your credentials.');
        }
      } else {
        saveProfileToLocalStorage(data);
      }
    }
  };
  const updateFormValue = ({ updateType, value }) => {
    setErrorMessage('');
    setLoginObj({ ...loginObj, [updateType]: value });
  };

  async function signInWithGoogle() {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        // We don't redirect to PLUGIN_URL/login.html because
        // supabase doesn't let us redirect to a site with a file
        // extension. It goes straight to the root url instead.
        // So, we just redirect from the root url to the login page
        redirectTo: PLUGIN_URL,
        queryParams: {
          // Ask to select which google account to use every time
          prompt: 'consent',
        },
      },
    });
    if (error) {
      console.error(error);
      return;
    }
  }

  async function signInWithFacebook() {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'facebook',
      options: {
        redirectTo: PLUGIN_URL,
      },
    });
    if (error) {
      console.error(error);
      return;
    }
  }

  async function signInWithGithub() {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'github',
      options: {
        redirectTo: PLUGIN_URL,
      },
    });
    if (error) {
      console.error(error);
      return;
    }
  }

  async function signInWithAzure() {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'azure',
      options: {
        redirectTo: PLUGIN_URL,
        scopes: 'email',
      },
    });
    if (error) {
      console.error(error);
      return;
    }
  }

  // Check for server error
  let errorDescription = searchParams.get('error_description');
  if (errorDescription !== null) {
    // Check if description starts with "Multiple accounts"
    if (errorDescription.startsWith('Multiple accounts')) {
      errorDescription =
        'An account with the same email address already ' +
        'exists. Please try logging in with your email address and password.';
    }
    if (errorMessage !== errorDescription) {
      setErrorMessage(errorDescription);
    }
  }

  return (
    <div className="min-h-screen bg-base-200 flex items-center">
      <div className="card mx-auto w-full max-w-5xl  shadow-xl">
        <div className="grid  md:grid-cols-2 grid-cols-1  bg-base-100 rounded-xl">
          <div className="">
            <LandingIntro />
          </div>
          <div className="py-24 px-10">
            <h2 className="text-2xl font-semibold mb-2 text-center">Login</h2>
            <button
              className={'btn mt-2 w-full btn-google'}
              onClick={signInWithGoogle}
            >
              <img
                src={'./assets/btn_google_logo.svg'}
                className="w-5 h-5 mr-2"
              />
              Sign In With Google
            </button>
            {/* <button className={"btn mt-2 w-full btn-google"} onClick={signInWithAzure}>
                            <img src={"./assets/btn_microsoft_logo.svg"} className="w-5 h-5 mr-2" />
                            Sign In With Microsoft
                        </button> */}
            <button
              className={'btn mt-2 w-full btn-google'}
              onClick={signInWithFacebook}
            >
              <img
                src={'./assets/btn_facebook_logo.svg'}
                className="w-5 h-5 mr-2"
              />
              Sign In With Facebook
            </button>
            <button
              className={'btn mt-2 w-full btn-google'}
              onClick={signInWithGithub}
            >
              <img
                src={'./assets/btn_github_logo.svg'}
                className="w-5 h-5 mr-2"
              />
              Sign In With Github
            </button>

            <form onSubmit={(e) => submitForm(e)}>
              <div className="mb-4">
                <InputText
                  type="emailId"
                  defaultValue={loginObj.emailId}
                  updateType="emailId"
                  containerStyle="mt-4"
                  labelTitle="Email Id"
                  updateFormValue={updateFormValue}
                />

                <InputText
                  defaultValue={loginObj.password}
                  type="password"
                  updateType="password"
                  containerStyle="mt-4"
                  labelTitle="Password"
                  updateFormValue={updateFormValue}
                />
              </div>

              <div className="text-right text-primary">
                <a
                  href="https://app.gptzero.me/forgot-password"
                  target="_blank"
                >
                  <span className="text-sm  inline-block  hover:text-primary hover:underline hover:cursor-pointer transition duration-200">
                    Forgot Password? (Opens in browser)
                  </span>
                </a>
              </div>

              <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>

              <HCaptcha
                ref={captcha}
                sitekey={HCAPTCHA_SITEKEY}
                onVerify={(token) => {
                  setCaptchaToken(token);
                }}
                onError={() => {
                  console.error(
                    'Captcha failed. Please refresh the page and try again.'
                  );
                  setCaptchaToken(null);
                  captcha.current?.resetCaptcha();
                }}
                onExpire={() => {
                  setCaptchaToken(null);
                  captcha.current?.resetCaptcha();
                }}
              />

              <button
                type="submit"
                className={
                  'btn mt-2 w-full btn-primary' + (loading ? ' loading' : '')
                }
              >
                Login
              </button>

              <div className="text-center mt-4">
                Don't have an account yet?{' '}
                <a href="https://app.gptzero.me/register" target="_blank">
                  <span className="  inline-block  hover:text-primary hover:underline hover:cursor-pointer transition duration-200">
                    Register (Opens in browser)
                  </span>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
